import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Box, Typography, Button, Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    backgroundColor: '#f5f5f5',
    padding: theme.spacing(3),
  },
  paper: {
    padding: theme.spacing(4),
    maxWidth: 500,
    textAlign: 'center',
  },
  icon: {
    fontSize: 64,
    color: theme.palette.error.main,
    marginBottom: theme.spacing(2),
  },
  title: {
    marginBottom: theme.spacing(2),
    fontWeight: 600,
  },
  message: {
    marginBottom: theme.spacing(3),
    color: theme.palette.text.secondary,
  },
  button: {
    marginTop: theme.spacing(2),
  },
}));

const AuthError: React.FC = () => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const [errorMessage, setErrorMessage] = useState<string>('Authentication failed');

  useEffect(() => {
    // Extract error message from URL query params
    const params = new URLSearchParams(location.search);
    const message = params.get('message');
    
    if (message) {
      setErrorMessage(decodeURIComponent(message));
    }
  }, [location]);

  const handleReturnToLogin = () => {
    history.push('/');
  };

  return (
    <Box className={classes.container}>
      <Paper className={classes.paper} elevation={3}>
        <ErrorOutlineIcon className={classes.icon} />
        <Typography variant="h4" className={classes.title}>
          Authentication Error
        </Typography>
        <Typography variant="body1" className={classes.message}>
          {errorMessage}
        </Typography>
        <Button
          variant="contained"
          color="primary"
          size="large"
          className={classes.button}
          onClick={handleReturnToLogin}
        >
          Return to Login
        </Button>
      </Paper>
    </Box>
  );
};

export default AuthError;
